module.exports = __webpack_public_path__ + "static/media/appLab_rps.95ffb770.png";